import { Controller } from '@hotwired/stimulus';

// Expand/collapse for the quick-apply job-details bar. The expanded body
// overlays the step content on purpose (see quick_apply_step_controller.js),
// so toggling is pure show/hide — no re-measuring.
//
//   data-controller="job-details-component"
export default class extends Controller {
  static targets = ['body', 'showButton', 'hideButton'];

  expand() {
    this.bodyTarget.hidden = false;
    this.showButtonTarget.hidden = true;
    this.setExpanded(true);
    this.hideButtonTarget.focus();
  }

  collapse() {
    this.bodyTarget.hidden = true;
    this.showButtonTarget.hidden = false;
    this.setExpanded(false);
    this.showButtonTarget.focus();
  }

  setExpanded(expanded) {
    [this.showButtonTarget, this.hideButtonTarget].forEach(button => {
      button.setAttribute('aria-expanded', String(expanded));
    });
  }
}
